<template>
  <div class="page-content detail">
    <div class="form-title">
      <i
        class="icon"
        :class="currentMenu.imgUrl||'el-icon-document'"
      ></i>
      {{ title }}
      <el-button
        plain
        type="primary"
        @click="backParent"
      >返回
      </el-button>
      <span
        class="btn-box"
        v-if="toolConfig"
      >
        <el-button
          v-for="btn in toolConfig"
          plain
          type="primary"
          :key="btn.code"
          @click="btnClick(btn)"
        >{{ btn.label || btn.name }}</el-button>
      </span>
      <!--      <span-->
      <!--        class="back-txt fr el-icon-d-arrow-left"-->
      <!--        @click="backParent"-->
      <!--      >返回</span>-->
    </div>
    <div>
      <el-form
        class="form-box"
        v-loading="loading"
      >
        <div
          v-show="detailOptions.statusOption"
          class="status-image"
          :style="detailStyle"
        ></div>
        <el-row>
          <el-col
            v-for="(column,index) in detailOptions.columns"
            :key="index"
            :span="column.isAllline ? 24 : (column.span||detailOptions.span)"
            :style="column.style"
          >
            <el-col :span="column.isAllline ? (column.span||detailOptions.span) : 24">
              <el-form-item
                :label="column.label"
                :label-width="column.label.length>0 ? detailOptions.labelWidth:'0px'"
              >
                <!--文件上传-->
                <file-upload
                  :ref="column.prop"
                  :disabledProp="true"
                  v-if="column.type === columnType.uploadFile"
                  :fileOptions="column"
                ></file-upload>
                <img
                  class="detail-img"
                  @click="itemFun(column.click, detailOptions.formData)"
                  v-else-if="column.type && column.type === columnType.image"
                  :src="column.defaultValue ? column.defaultValue : (detailOptions.formData&& detailOptions.formData[column.prop])"
                />
                <span
                  v-else-if="column.merge"
                  v-for="(p,index) in column.prop.split(',')"
                  :key="index"
                >
                  {{ detailOptions.formData && detailOptions.formData[p] }}
                </span>
                <div
                  v-else-if="column.enumData"
                  v-html="$utils.getEnumItem(column,detailOptions.formData&&detailOptions.formData[column.prop])"
                ></div>
                <span
                  v-else-if="column.deal">{{
                    column.deal(detailOptions.formData && detailOptions.formData[column.prop])
                  }}</span>
                <span v-else>{{ detailOptions.formData && detailOptions.formData[column.prop] }}</span>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <!--<div-->
        <!--v-for="(tableOptions,tbindex) in detailOptions.tablesProp"-->
        <!--:key="tbindex"-->
        <!--class="table-box"-->
      <!--&gt;-->
        <!--<list-template-->
          <!--:tableData="tableData[tbindex]"-->
          <!--:tableOptions="tableOptions"-->
        <!--&gt;</list-template>-->
      <!--</div>-->
      <purchase-list-template
        ref="listTable"
        :tableOptions="detailOptions.tablesProp.weAdjustGoodsMapMVOList"
      ></purchase-list-template>
    </div>
    <div
      id="detailInfo"
      class="print-dom"
    >
      <el-form
        class="form-box"
        v-loading="loading"
      >
        <div
          v-show="detailOptions.statusOption"
          class="status-image"
        >
          <img :src="detailStyle.src"/>
        </div>
        <el-row>
          <p class="print-title">{{ storeName }}库存调整单</p>
          <el-col
            v-for="(column,index) in detailOptions.columns"
            :key="index"
            :span="column.isAllline ? 24 : (column.span||detailOptions.span)"
            :style="column.style"
          >
            <el-col :span="column.isAllline ? (column.span||detailOptions.span) : 24">
              <el-form-item
                :label="column.label"
                :label-width="column.label.length>0 ? detailOptions.labelWidth:'0px'"
              >
                <!--文件上传-->
                <file-upload
                  :ref="column.prop"
                  :disabledProp="true"
                  v-if="column.type === columnType.uploadFile"
                  :fileOptions="column"
                ></file-upload>
                <img
                  class="detail-img"
                  @click="itemFun(column.click, detailOptions.formData)"
                  v-else-if="column.type && column.type === columnType.image"
                  :src="column.defaultValue ? column.defaultValue : (detailOptions.formData&& detailOptions.formData[column.prop])"
                />
                <span
                  v-else-if="column.merge"
                  v-for="(p,index) in column.prop.split(',')"
                  :key="index"
                >
                  {{ detailOptions.formData && detailOptions.formData[p] }}
                </span>
                <div
                  v-else-if="column.enumData"
                  v-html="$utils.getEnumItem(column,detailOptions.formData&&detailOptions.formData[column.prop])"
                ></div>
                <span
                  v-else-if="column.deal">{{
                    column.deal(detailOptions.formData && detailOptions.formData[column.prop])
                  }}</span>
                <span v-else>{{ detailOptions.formData && detailOptions.formData[column.prop] }}</span>
              </el-form-item>
            </el-col>
          </el-col>

        </el-row>
      </el-form>
      <div
        v-for="(tableOptions,tbindex) in detailOptions.printTablesProp"
        :key="tbindex"
        class="table-box"
      >
        <!-- <list-template
          :tableData="tableData[tbindex]"
          :tableOptions="tableOptions"
        ></list-template> -->
        <table
          style="table-layout:fixed"
          border="1"
          cellspacing="0"
          width="100%"
        >
          <tbody class="print-table">
          <tr>
            <td width="130">条码</td>
            <td>商品名称</td>
            <td>进货规格</td>
            <td>价格</td>
            <td>数量</td>
            <td>小计金额</td>
            <td>备注</td>
          </tr>
          <tr v-for="(item, index) of tableData[tbindex]" :key="index">
            <td>{{ item.barCode }}</td>
            <td>{{ item.goodsName }}</td>
            <td>{{ item.specs }}</td>
            <td>{{ item.purchasePrice }}</td>
            <td>{{ item.goodsNum }}</td>
            <td>{{ item.totalPrice }}</td>
            <td>{{ item.remarks }}</td>
          </tr>
          <tr>
            <td>合计</td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ goodsNum.toFixed(2) }}</td>
            <td>{{ totalPrice.toFixed(2) }}</td>
            <td></td>
          </tr>
          </tbody>
        </table>

      </div>
      <div class="print-person-sign">
        <p>制单：</p>
        <p>经办：</p>
        <p>签收：</p>
      </div>
    </div>
  </div>
</template>
<script>
import listTemplate from "@/components/template/listTemplate";
import api from '@/config/api';
import purchaseListTemplate from "@/components/template/purchaseListTemplate.vue";

export default {
  components: {
    listTemplate,
    purchaseListTemplate
  },
  data() {
    return {
      loading: false,
      detailOptions: {formData: {}},
      headList: [],
      currentMenu: {},
      tableData: {}, //表格数据层次太深，需要在当前对象中创建
      title: "",
      detailStyle: {},
      columnType: {
        image: "image", //图片
        file: "file", //图片
        uploadFile: "uploadFile",
      },
      toolConfig: [
        // {label: "打印", code: "print", callback: this.print},
        {label: "导出", code: "exportData", callback: this.exportData},
      ],
      storeName: '',
      goodsNum: 0,
      totalPrice: 0
    };
  },
  created() {
    this.storeName = JSON.parse(localStorage.getItem('SYSUSER')).storeName
    this.currentMenu = this.$utils.getCurrentMune();
    this.title = document.title;

    this.detailOptions = this.$utils.getDataByKey(
      this.$utils.storeKeys.FORMINFO
    );
    if (!this.detailOptions) {
      this.detailOptions = this.$store.state[this.$utils.storeKeys.FORMINFO];
    }else {
      this.$utils.clearDetailData(this.$utils.storeKeys.FORMINFO);
    }
    this.getDetail();
  },
  methods: {
    print() {
      this.$utils.print("detailInfo", this.$utils.getEnumItem());
    },
    exportData() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = {
        id: this.$route.query.id,
        orderNo: this.detailOptions.formData.orderNo,
        headList: this.headArray,
        auditDesc: this.$utils.getCacheStatusValue('weAdjustInventoryOrder.reviewerStatus', this.detailOptions.formData.reviewerStatus),
      };
      this.$axios.PostBlob(api.warehouse.adjustInventoryExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '库存调整单详情_' + param.orderNo + '_' + this.$utils.getDateTime() + ".xlsx";
          console.log(fileName);
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.warning("当前导出数据为空或超出10000条。");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
    btnClick(btn) {
      btn.callback(
        this.$route.query.id,
        this.detailOptions.formData,
        this.tableData
      );
    },
    itemFun(bindFun, data) {
      bindFun && bindFun(data);
    },
    getDetail() {
      this.loading = true;
      this.$axios
        .fetchGet(this.detailOptions.url + "?id=" + this.$route.query.id, {})
        .then((data) => {
          this.loading = false;
          if (data.code == 200 && data.data) {
            this.detailOptions.formData = data.data;
            this.headArray = this.$utils.getHeadData(this.detailOptions.columns, data.data);
            // 表格数据
            // this.detailOptions.tablesProp &&
            // Object.keys(this.detailOptions.tablesProp).map((key) => {
            //   if (Array.isArray) {
            //     if (Array.isArray(data.data[key])) {
            //       data.data[key].forEach((item, index) => {
            //         item.indexShow = index + 1;
            //       });
            //       this.$set(this.tableData, key, data.data[key]);
            //     }
            //   } else {
            //     this.$set(this.tableData, key, data.data[key]);
            //   }
            // });
            // let obj = this.detailOptions.printTablesProp;
            // for (let key in obj) {
            //   this.tableData[key].forEach(v => {
            //     this.goodsNum += Number(v.goodsNum);
            //     this.totalPrice += Number(v.totalPrice);
            //   });
            // }
            this.getTableData();
            //图片状态
            if (this.detailOptions.statusOption) {
              this.detailStyle = {
                backgroundImage:
                  "url(" +
                  this.detailOptions.statusOption.statusImg[
                  this.detailOptions.formData &&
                  this.detailOptions.formData[
                    this.detailOptions.statusOption.prop
                    ]
                    ] +
                  ")",
                src: this.detailOptions.statusOption.statusImg[
                this.detailOptions.formData &&
                this.detailOptions.formData[
                  this.detailOptions.statusOption.prop
                  ]
                  ],
                left: this.detailOptions.statusOption.left || "unset",
                right: this.detailOptions.statusOption.right || "unset",
                top: this.detailOptions.statusOption.top || "unset",
                bottom: this.detailOptions.statusOption.bottom || "unset",
              };
            }
            this.$nextTick(() => {
              this.detailOptions.columns.map((item) => {
                if (
                  item.type === this.columnType.uploadFile &&
                  data.data.attachments
                ) {
                  // 文件上传
                  this.$refs[item.prop][0].fileList =
                    data.data.attachments[item.prop];
                  this.$refs[item.prop][0].disabled = true;
                }
              });
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getTableData() {
      this.$nextTick(() => {
        this.$refs["listTable"].initData({
          adjustId: this.$route.query.id
        });
      });
    },
    backParent() {
      if (this.$route.path == this.$route.query.redirect) return;
      this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, null);
      this.$router.push({path: this.$route.query.redirect});
    },
  },
  destroyed() {
    this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, null);
  },
};
</script>
<style>
.detail.page-content .form-title .back-txt {
  color: #409eff;
  font-size: 14px;
  margin-right: 10px;
  margin-left: 10px;
  cursor: pointer;
}

.detail.page-content .form-box {
  padding: 20px;
}

.detail.page-content .table-box {
  margin-top: 20px;
  padding: 20px;
  border-radius: 5px;
  max-width: 100%;
}

.detail.page-content .form-box {
  min-height: unset;
  position: relative;
}

.detail.page-content .detail-img {
  width: 50px;
}

.detail.page-content {
  padding-bottom: 30px;
}

.page-content.detail .status-image {
  position: absolute;
  top: 10px;
  right: 350px;
  width: 164px;
  height: 87px;
  background-size: 100% 100%;
  z-index: 1000;
}

.page-content.detail .btn-box {
  margin-left: 10px;
}

.print-dom {
  display: none;
  /* position: absolute;
  z-index: -1111;
  top: 0;
  left: 0; */
}
</style>




// WEBPACK FOOTER //
// src/page/warehouse/BusinessDetail.vue